


























































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import moment from 'moment-timezone'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { formatarMoeda, formatarDecimal } from '@/shareds/formatadores'
import { primaryColor } from '@/plugins/vuetify'
import { FindDashboardsUseCase, FindDadosDeVendasUsecase } from '@/usecases'
import { ViewPerfilDashboard, PercVendasComClientes } from '@/models/views/CapaDashboard'
import SeletorDeLojasCompacto from '@/components/loja/SeletorDeLojasCompacto.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import SecaoTabela from '@/components/dashboard/SecaoTabela.vue'
import SecaoDemonstracoes from '@/components/dashboard/SecaoDemonstracoes.vue'
import { gerarRelatorioDashboard } from '@/shareds/dashboard/gerar-relatorio-dashboard'
import Axios, { CancelTokenSource } from 'axios'
import { listaDeRecursos } from '@/shareds/permissoes-shareds'
import itensDeMenu, { ItemDeMenu } from '@/shareds/itensDeMenu'

@Component({
	components: { SeletorDeLojasCompacto, RangeDatePicker, SecaoTabela, SecaoDemonstracoes },
})
export default class Home extends Vue {
	formatarMoeda = formatarMoeda

	findDashBoardUseCase = new FindDashboardsUseCase()
	findDadosDeVendasUseCase = new FindDadosDeVendasUsecase()

	lojasSelecionadas: string[] = []
	periodoSelecionado = 'hoje'
	datasPersonalizadas: string[] = []

	permissoesDash: ViewPerfilDashboard[] = []
	carregando = false
	cancelToken: CancelTokenSource | null = null

	vendaPorLoja: any[] = []
	vendedor: any[] = []
	marca: any[] = []
	externasInternas: any[] = []
	demonstracao: any[] = []
	percVendasComESemCliente: PercVendasComClientes | null = null

	headersVendasPorLoja = [
		{ text: 'Loja', value: 'loja', sortable: false },
		{ text: 'Vlr Líq', value: 'faturamento', sortable: false, align: 'end' },
		{ text: 'PÇ', value: 'qtdeDePecas', sortable: false, align: 'end' },
		{ text: 'Vendas', value: 'somaDeVendas', sortable: false, align: 'end' },
		{ text: 'TM', value: 'ticketMedio', sortable: false, align: 'end' },
		{ text: 'PM', value: 'precoMedio', sortable: false, align: 'end' },
		{ text: 'PA', value: 'pa', sortable: false, align: 'end' },
	]
	headersVendasPorVendedor = [
		{ text: 'Vendedor', value: 'vendedor', sortable: true },
		{ text: 'Vlr Líq', value: 'faturamento', sortable: true, align: 'end' },
		{ text: 'PÇ', value: 'qtdeDePecas', sortable: true, align: 'end' },
		{ text: 'Dev', value: 'devolucoes', sortable: true, align: 'end' },
		{ text: 'Demo', value: 'demonstracao', sortable: true, align: 'end' },
		{ text: 'Omni', value: 'ecommerce', sortable: true, align: 'end' },
		{ text: 'Presencial', value: 'interna', sortable: true, align: 'end' },
		{ text: 'Link', value: 'link', sortable: true, align: 'end' },
		{ text: 'Outros', value: 'outro', sortable: true, align: 'end' },
		{ text: 'Vendas', value: 'somaDeVendas', sortable: true, align: 'end' },
		{ text: 'TM', value: 'ticketMedio', sortable: true, align: 'end' },
		{ text: 'PM', value: 'precoMedio', sortable: true, align: 'end' },
		{ text: 'PA', value: 'pa', sortable: true, align: 'end' },
	]
	headersVendasPorMarca = [
		{ text: 'Marca', value: 'marca', sortable: false },
		{ text: 'Vlr Líq', value: 'faturamento', sortable: false, align: 'end' },
		{ text: 'PÇ', value: 'qtdeDePecas', sortable: false, align: 'end' },
		{ text: 'Dev', value: 'devolucoes', sortable: false, align: 'end' },
		{ text: 'Demo', value: 'demonstracao', sortable: false, align: 'end' },
		{ text: 'Omni', value: 'ecommerce', sortable: false, align: 'end' },
		{ text: 'Presencial', value: 'interna', sortable: false, align: 'end' },
		{ text: 'Link', value: 'link', sortable: false, align: 'end' },
		{ text: 'Outros', value: 'outro', sortable: false, align: 'end' },
		{ text: 'Vendas', value: 'somaDeVendas', sortable: false, align: 'end' },
	]
	headersExternasInternas = [
		{ text: 'Origem', value: 'tipo', sortable: false },
		{ text: 'Vlr Líq', value: 'faturamento', sortable: false, align: 'end' },
		{ text: '%', value: 'perc', sortable: false, align: 'end' },
		{ text: 'PÇ', value: 'pecas', sortable: false, align: 'end' },
		{ text: 'Vendas', value: 'numeroDeVendas', sortable: false, align: 'end' },
		{ text: 'TM', value: 'tm', sortable: false, align: 'end' },
		{ text: 'PM', value: 'pm', sortable: false, align: 'end' },
		{ text: 'PA', value: 'pa', sortable: false, align: 'end' },
	]
	headersDemonstracao = [
		{ text: 'Vendedor', value: 'vendedor', sortable: false },
		{ text: 'Cliente', value: 'cliente', sortable: false, align: 'end' },
		{ text: 'Total em aberto', value: 'total', sortable: false, align: 'end' },
		{ text: 'Preço médio', value: 'precoMedio', sortable: false, align: 'end' },
		{ text: 'QTD peças', value: 'quantidade', sortable: false, align: 'end' },
		{ text: 'Dias em aberto', value: 'diasEmAberto', sortable: false, align: 'end' },
		{ text: 'Nota fiscal', value: 'notaFiscal', sortable: false, align: 'end' },
		{ text: 'Identificador', value: 'identificador', sortable: false, align: 'end' },
	]

	modulos = [
		{ icone: 'mdi-account-group', titulo: 'Fila da Vez', descricao: 'Distribua atendimentos com justiça e meça a conversão de cada vendedor em tempo real.', url: 'https://www.almode.com/fila-da-vez/' },
		{ icone: 'mdi-bag-personal', titulo: 'Malinha Digital', descricao: 'Leve a vitrine até o cliente e transforme demonstrações em vendas rastreadas.', url: 'https://www.almode.com/malinha-digital/' },
		{ icone: 'mdi-calendar-heart', titulo: 'Agenda & CRM', descricao: 'Histórico, follow-ups e WhatsApp integrados: relacionamento que fideliza e revende.', url: 'https://www.almode.com/agenda-do-vendedor/' },
		{ icone: 'mdi-diamond-stone', titulo: 'RFV', descricao: 'Recência, frequência e valor: saiba quem é campeão, quem está em risco e aja na hora certa.', url: 'https://www.almode.com/rfv/' },
		{ icone: 'mdi-cellphone-link', titulo: 'Catálogo Digital', descricao: 'Link no WhatsApp com checkout direto, estoque em tempo real e zero instalação.', url: 'https://www.almode.com/catalogo-digital/' },
		{ icone: 'mdi-credit-card-outline', titulo: 'Almode Pay', descricao: 'PIX, cartão e boleto já conciliados dentro do seu ERP — sem maquininha separada.', url: 'https://www.almode.com/' },
		{ icone: 'mdi-robot-outline', titulo: 'Coach IA', descricao: 'Escuta o atendimento, aponta a objeção que derrubou a venda e treina a equipe — sem guardar áudio.', url: 'https://www.almode.com/' },
		{ icone: 'mdi-trophy-outline', titulo: 'Ranking & Gamificação', descricao: 'A equipe que compete, vende mais: ranking em tempo real de faturamento, conversão, ticket médio e PA — times que veem os números vendem até 23% mais.', url: 'https://www.almode.com/' },
	]

	created() {
		const rotaInicial = this.rotaDaTelaInicial(UserLoginStore.perfil?.telaInicial)
		if (rotaInicial) {
			this.$router.push({ name: rotaInicial })
			return
		}
		this.iniciar()
	}

	rotaDaTelaInicial(telaInicial?: string): string | null {
		if (!telaInicial) return null
		const rotas = this.$router.getRoutes()
		const rotaExiste = (nome?: string) => !!nome && nome !== this.$route.name && rotas.some(rota => rota.name === nome)
		if (rotaExiste(telaInicial)) return telaInicial

		const recurso = listaDeRecursos.find(r => r.nome === telaInicial || r.chave === telaInicial)
		if (recurso) {
			const achatar = (itens: ItemDeMenu[]): ItemDeMenu[] => itens.flatMap(item => [item, ...achatar(item.children || [])])
			const itensDoRecurso = achatar(itensDeMenu).filter(item => item.recurso === recurso.chave)
			const nomeDaRota = (item?: ItemDeMenu) => (item?.route as { name?: string } | undefined)?.name
			const doMenu = [
				...itensDoRecurso.filter(item => item.title === recurso.nome),
				...itensDoRecurso.filter(item => !item.operacao || item.operacao === 'ler'),
				...itensDoRecurso,
			].map(nomeDaRota).find(rotaExiste)
			if (doMenu) return doMenu

			const doRouter = rotas
				.filter(rota => rota.meta?.recurso === recurso.chave && !rota.path.includes(':'))
				.sort((a, b) => a.path.length - b.path.length)
				.map(rota => rota.name)
				.find(rotaExiste)
			if (doRouter) return doRouter
		}

		return null
	}

	async iniciar() {
		const idPerfil = UserLoginStore.usuario?.perfil?.id
		if (idPerfil) {
			try { this.permissoesDash = await this.findDashBoardUseCase.listarDashPorPerfil(idPerfil) } catch (e) { /* segue */ }
		}
		this.buscarDados()
	}

	temPermissao(nome: string): boolean {
		return !this.permissoesDash.length || this.permissoesDash.some(p => p.nomeDaCapa === nome)
	}

	// Botão do dashboard clássico só aparece p/ quem tem acesso à tela antiga (recurso 'dashboards'),
	// mesmo gate do menu/rota (ler/dashboards).
	get podeVerDashboardAntigo(): boolean {
		return !!UserLoginStore.temAutorizacaoPorOperacaoERecurso('ler', 'dashboards')
	}

	get umaLoja(): boolean {
		return !this.lojasSelecionadas || this.lojasSelecionadas.length <= 1
	}
	get temAlgumaSecaoDeUmaLoja(): boolean {
		return ['Vendas Por Vendedor Orcamento', 'Vendas Por Marca', 'Vendas Externas e Internas Orcamento', 'Demonstracoes Em Aberto']
			.some(n => this.temPermissao(n))
	}

	get primeiroNome(): string { return UserLoginStore.usuario?.nome?.split(' ')[0] || '' }
	get saudacao(): string {
		const h = moment().hour()
		if (h < 12) return 'Bom dia'
		if (h < 18) return 'Boa tarde'
		return 'Boa noite'
	}

	get estiloFundo(): any {
		return this.$vuetify.theme.dark ? {} : { backgroundColor: '#f3f2f7', minHeight: '100%' }
	}

	toNumber(valor: any): number {
		if (typeof valor === 'number') return valor
		const n = Number(valor)
		return isNaN(n) ? 0 : n
	}
	moeda(valor: any): string { return 'R$ ' + formatarMoeda(this.toNumber(valor)) }

	formatarCampos(item: any, campos: string[]): any {
		const novo = { ...item }
		campos.forEach(c => { novo[c] = this.moeda(novo[c]) })
		return novo
	}

	dataMaterializacao(itens: any[]): string {
		const datas = (itens || []).map(i => i.dataHoraMaterializada).filter(Boolean)
		if (!datas.length) return ''
		const max = datas.reduce((a, b) => (a > b ? a : b))
		// Sempre em horário de Brasília, independente do fuso da máquina.
		return moment(max).tz('America/Sao_Paulo').format('DD/MM/YYYY [às] HH:mm')
	}

	get nomeEmpresa(): string {
		const sub = window.location.hostname.split('.')[0] || ''
		return sub ? sub.charAt(0).toUpperCase() + sub.slice(1) : ''
	}

	dialogoExportar = false
	kpisSelecionados: string[] = []
	secoesSelecionadas: string[] = []

	headersDemExport = [
		{ text: 'Vendedor', value: 'vendedor' },
		{ text: 'Cliente', value: 'cliente' },
		{ text: 'Total em aberto', value: 'total', align: 'end' },
		{ text: 'Preço médio', value: 'precoMedio', align: 'end' },
		{ text: 'QTD peças', value: 'quantidade', align: 'end' },
		{ text: 'Dias em aberto', value: 'diasEmAberto', align: 'end' },
		{ text: 'Identificador', value: 'identificador', align: 'end' },
	]

	get listaSecoes(): any[] {
		const arr: any[] = []
		if (this.temPermissao('Vendas Orcamento Por Loja')) arr.push({ chave: 'vendaloja', titulo: 'Vendas por loja', headers: this.headersVendasPorLoja, getItens: () => this.fmtVendaPorLoja })
		if (this.umaLoja) {
			if (this.temPermissao('Vendas Por Vendedor Orcamento')) arr.push({ chave: 'vendedor', titulo: 'Vendas por vendedor', headers: this.headersVendasPorVendedor, getItens: () => this.fmtVendedor })
			if (this.temPermissao('Vendas Por Marca')) arr.push({ chave: 'marca', titulo: 'Vendas por marca', headers: this.headersVendasPorMarca, getItens: () => this.fmtMarca })
			if (this.temPermissao('Vendas Externas e Internas Orcamento')) arr.push({ chave: 'externas', titulo: 'Vendas externas e internas', headers: this.headersExternasInternas, getItens: () => this.fmtExternasInternas })
			if (this.temPermissao('Demonstracoes Em Aberto')) arr.push({ chave: 'demonstracoes', titulo: 'Demonstrações de lojas', headers: this.headersDemExport, getItens: () => this.demonstracao.map(i => ({ ...i, total: this.moeda(i.total), precoMedio: this.moeda(i.precoMedio) })) })
		}
		return arr
	}

	get secoesDisponiveis(): any[] {
		return [{ chave: 'barras', titulo: 'Faturamento por loja (gráfico)' }, ...this.listaSecoes.map(s => ({ chave: s.chave, titulo: s.titulo }))]
	}

	abrirExportar() {
		this.kpisSelecionados = this.kpis.map(k => k.titulo)
		this.secoesSelecionadas = this.secoesDisponiveis.map(s => s.chave)
		this.dialogoExportar = true
	}

	exportarRelatorio() {
		const fmt = (iso?: string) => (iso ? moment(iso).tz('America/Sao_Paulo').format('DD/MM/YYYY') : '')
		const labels: Record<string, string> = { hoje: 'Hoje', ontem: 'Ontem', semana: 'Esta semana', mes: 'Este mês', personalizado: 'Período personalizado' }
		const datas = this.datasDoPeriodo
		const periodoLabel = `${labels[this.periodoSelecionado] || ''} (${fmt(datas?.dataInicial)} - ${fmt(datas?.dataFinal)})`
		const lojasLabel = this.lojasSelecionadas && this.lojasSelecionadas.length
			? (Array.from(new Set(this.vendaPorLoja.map(l => l.loja).filter(Boolean))).join(', ') || `${this.lojasSelecionadas.length} loja(s)`)
			: 'Todas as lojas'

		const kpisSel = this.kpis.filter(k => this.kpisSelecionados.includes(k.titulo)).map(k => ({ titulo: k.titulo, valor: k.valor }))
		const secoes = this.listaSecoes
			.filter(s => this.secoesSelecionadas.includes(s.chave))
			.map(s => ({ titulo: s.titulo, headers: s.headers, itens: s.getItens() }))

		let barras: any[] = []
		if (this.secoesSelecionadas.includes('barras')) {
			const maxFat = Math.max(...this.vendaPorLoja.map(l => this.toNumber(l.faturamento)), 1)
			barras = [...this.vendaPorLoja]
				.sort((a, b) => this.toNumber(b.faturamento) - this.toNumber(a.faturamento))
				.map(l => ({ label: l.loja, valor: this.moeda(l.faturamento), pct: (this.toNumber(l.faturamento) / maxFat) * 100 }))
		}

		gerarRelatorioDashboard({
			corPrimaria: primaryColor(),
			empresa: this.nomeEmpresa,
			periodoLabel,
			lojasLabel,
			geradoEm: moment().tz('America/Sao_Paulo').format('DD/MM/YYYY [às] HH:mm'),
			heroValor: this.moeda(this.totais.fat),
			heroLabel: 'Faturamento no período',
			kpis: kpisSel,
			barras,
			secoes,
		})
		this.dialogoExportar = false
	}

	// Agregados a partir da view materializada de vendas por loja
	get totais() {
		const fat = this.vendaPorLoja.reduce((s, i) => s + this.toNumber(i.faturamento), 0)
		const vendas = this.vendaPorLoja.reduce((s, i) => s + this.toNumber(i.somaDeVendas), 0)
		const pecas = this.vendaPorLoja.reduce((s, i) => s + this.toNumber(i.qtdeDePecas), 0)
		return {
			fat, vendas, pecas,
			tm: vendas ? fat / vendas : 0,
			pa: vendas ? pecas / vendas : 0,
			pm: pecas ? fat / pecas : 0,
		}
	}

	get kpis() {
		const t = this.totais
		return [
			{ titulo: 'Faturamento', icone: 'mdi-cash-multiple', cor: primaryColor(), corFundo: 'primary lighten-5', corIcone: 'primary', valor: this.moeda(t.fat) },
			{ titulo: 'Cupons / vendas', icone: 'mdi-receipt-text-outline', cor: '#0EB5CB', corFundo: 'cyan lighten-5', corIcone: 'cyan darken-1', valor: String(t.vendas) },
			{ titulo: 'Ticket médio', icone: 'mdi-chart-line', cor: '#FB8C00', corFundo: 'amber lighten-5', corIcone: 'amber darken-2', valor: this.moeda(t.tm) },
			{ titulo: 'PA (média)', icone: 'mdi-tshirt-crew-outline', cor: '#43A047', corFundo: 'green lighten-5', corIcone: 'green darken-1', valor: t.pa.toFixed(2) },
			{ titulo: 'PM (preço médio)', icone: 'mdi-tag-outline', cor: '#8E24AA', corFundo: 'purple lighten-5', corIcone: 'purple darken-1', valor: this.moeda(t.pm) },
		]
	}

	get participacoesNasVendas() {
		const perc = this.percVendasComESemCliente
		const montar = (valor: any) => {
			const percentual = this.toNumber(valor)
			return { percentual, texto: percentual.toFixed(2).replace('.', ',') + '%' }
		}
		return [
			{ rotulo: 'Com cliente', icone: 'mdi-account-check-outline', cor: primaryColor(), corFundo: 'primary lighten-5', corIcone: 'primary', ...montar(perc?.percComClientes) },
			{ rotulo: 'Sem cliente', icone: 'mdi-account-off-outline', cor: '#3949AB', corFundo: 'indigo lighten-5', corIcone: 'indigo darken-1', ...montar(perc?.percSemClientes) },
		]
	}

	corMedalha(i: number): string { return ['amber darken-2', 'blue-grey lighten-1', 'orange darken-3'][i] || 'grey lighten-1' }

	get topLojas(): any[] {
		return [...this.vendaPorLoja].sort((a, b) => this.toNumber(b.faturamento) - this.toNumber(a.faturamento)).slice(0, 5)
	}

	get faturamentoLojasSerie(): { categorias: string[]; valores: number[] } {
		const lojas = [...this.vendaPorLoja].sort((a, b) => this.toNumber(b.faturamento) - this.toNumber(a.faturamento))
		return { categorias: lojas.map(l => l.loja), valores: lojas.map(l => Math.round(this.toNumber(l.faturamento) * 100) / 100) }
	}
	get opcoesFatLojas(): any {
		return {
			chart: { type: 'bar', toolbar: { show: false }, fontFamily: 'inherit' },
			colors: [primaryColor()],
			plotOptions: { bar: { borderRadius: 6, columnWidth: '50%' } },
			dataLabels: { enabled: false },
			xaxis: { categories: this.faturamentoLojasSerie.categorias },
			yaxis: { labels: { formatter: (v: number) => formatarMoeda(v) } },
			tooltip: { y: { formatter: (v: number) => formatarMoeda(v) } },
			grid: { borderColor: 'rgba(128,128,128,0.15)' },
		}
	}

	get fmtVendaPorLoja(): any[] { return this.vendaPorLoja.map(i => this.formatarCampos(i, ['faturamento', 'ticketMedio', 'precoMedio'])) }
	get fmtVendedor(): any[] { return this.vendedor.map(i => this.formatarCampos(i, ['faturamento', 'devolucoes', 'demonstracao', 'ecommerce', 'interna', 'link', 'outro', 'ticketMedio', 'precoMedio'])) }
	get fmtMarca(): any[] { return this.marca.map(i => this.formatarCampos(i, ['faturamento', 'devolucoes', 'demonstracao', 'ecommerce', 'interna', 'link', 'outro'])) }
	get fmtExternasInternas(): any[] { return this.externasInternas.map(i => this.formatarCampos(i, ['faturamento', 'tm', 'pm'])) }
	get fmtDemonstracao(): any[] { return this.demonstracao.map(i => this.formatarCampos(i, ['total', 'precoMedio'])) }

	// Linha de totalizadores das tabelas do dashboard, calculada a partir dos dados crus.
	// 'moeda'/'inteiro' somam a coluna; 'ratioMoeda'/'ratioNum' recalculam a razão a partir
	// dos totais (somar médias por linha daria valor errado); 'perc' é sempre 100%.
	calcularTotais(itens: any[], spec: Array<{ value: string; tipo: string; num?: string; den?: string }>): Record<string, string> | null {
		if (!itens || !itens.length) return null
		const soma = (campo: string) => itens.reduce((s, i) => s + this.toNumber(i[campo]), 0)
		const totais: Record<string, string> = {}
		spec.forEach(s => {
			switch (s.tipo) {
				case 'moeda': totais[s.value] = this.moeda(soma(s.value)); break
				case 'inteiro': totais[s.value] = formatarDecimal(soma(s.value)); break
				case 'ratioMoeda': { const d = soma(s.den as string); totais[s.value] = this.moeda(d ? soma(s.num as string) / d : 0); break }
				case 'ratioNum': { const d = soma(s.den as string); const v = d ? soma(s.num as string) / d : 0; totais[s.value] = String(Math.round(v * 100) / 100); break }
				case 'perc': totais[s.value] = '100,00%'; break
			}
		})
		return totais
	}

	get totaisVendaPorLoja(): Record<string, string> | null {
		return this.calcularTotais(this.vendaPorLoja, [
			{ value: 'faturamento', tipo: 'moeda' },
			{ value: 'qtdeDePecas', tipo: 'inteiro' },
			{ value: 'somaDeVendas', tipo: 'inteiro' },
			{ value: 'ticketMedio', tipo: 'ratioMoeda', num: 'faturamento', den: 'somaDeVendas' },
			{ value: 'precoMedio', tipo: 'ratioMoeda', num: 'faturamento', den: 'qtdeDePecas' },
			{ value: 'pa', tipo: 'ratioNum', num: 'qtdeDePecas', den: 'somaDeVendas' },
		])
	}
	get totaisVendedor(): Record<string, string> | null {
		return this.calcularTotais(this.vendedor, [
			{ value: 'faturamento', tipo: 'moeda' },
			{ value: 'qtdeDePecas', tipo: 'inteiro' },
			{ value: 'devolucoes', tipo: 'moeda' },
			{ value: 'demonstracao', tipo: 'moeda' },
			{ value: 'ecommerce', tipo: 'moeda' },
			{ value: 'interna', tipo: 'moeda' },
			{ value: 'link', tipo: 'moeda' },
			{ value: 'outro', tipo: 'moeda' },
			{ value: 'somaDeVendas', tipo: 'inteiro' },
			{ value: 'ticketMedio', tipo: 'ratioMoeda', num: 'faturamento', den: 'somaDeVendas' },
			{ value: 'precoMedio', tipo: 'ratioMoeda', num: 'faturamento', den: 'qtdeDePecas' },
			{ value: 'pa', tipo: 'ratioNum', num: 'qtdeDePecas', den: 'somaDeVendas' },
		])
	}
	get totaisMarca(): Record<string, string> | null {
		return this.calcularTotais(this.marca, [
			{ value: 'faturamento', tipo: 'moeda' },
			{ value: 'qtdeDePecas', tipo: 'inteiro' },
			{ value: 'devolucoes', tipo: 'moeda' },
			{ value: 'demonstracao', tipo: 'moeda' },
			{ value: 'ecommerce', tipo: 'moeda' },
			{ value: 'interna', tipo: 'moeda' },
			{ value: 'link', tipo: 'moeda' },
			{ value: 'outro', tipo: 'moeda' },
			{ value: 'somaDeVendas', tipo: 'inteiro' },
		])
	}
	get totaisExternasInternas(): Record<string, string> | null {
		return this.calcularTotais(this.externasInternas, [
			{ value: 'faturamento', tipo: 'moeda' },
			{ value: 'perc', tipo: 'perc' },
			{ value: 'pecas', tipo: 'inteiro' },
			{ value: 'numeroDeVendas', tipo: 'inteiro' },
			{ value: 'tm', tipo: 'ratioMoeda', num: 'faturamento', den: 'numeroDeVendas' },
			{ value: 'pm', tipo: 'ratioMoeda', num: 'faturamento', den: 'pecas' },
			{ value: 'pa', tipo: 'ratioNum', num: 'pecas', den: 'numeroDeVendas' },
		])
	}

	ajustarData(data: moment.MomentInput, tipo: 'start' | 'end'): string {
		const base = moment(data).utcOffset('-03:00', true)
		return tipo === 'start' ? base.startOf('day').toISOString(true) : base.endOf('day').toISOString(true)
	}
	get datasDoPeriodo(): { dataInicial: string; dataFinal: string } | null {
		const agora = moment()
		switch (this.periodoSelecionado) {
			case 'hoje': return { dataInicial: this.ajustarData(agora, 'start'), dataFinal: this.ajustarData(agora, 'end') }
			case 'ontem': { const o = moment().subtract(1, 'day'); return { dataInicial: this.ajustarData(o, 'start'), dataFinal: this.ajustarData(o, 'end') } }
			case 'semana': return { dataInicial: this.ajustarData(moment().startOf('isoWeek'), 'start'), dataFinal: this.ajustarData(agora, 'end') }
			case 'mes': return { dataInicial: this.ajustarData(moment().startOf('month'), 'start'), dataFinal: this.ajustarData(agora, 'end') }
			case 'personalizado': {
				if (!this.datasPersonalizadas || !this.datasPersonalizadas[0]) return null
				return { dataInicial: this.ajustarData(this.datasPersonalizadas[0], 'start'), dataFinal: this.ajustarData(this.datasPersonalizadas[1] || this.datasPersonalizadas[0], 'end') }
			}
			default: return { dataInicial: this.ajustarData(agora, 'start'), dataFinal: this.ajustarData(agora, 'end') }
		}
	}
	montarParams(): any {
		const datas = this.datasDoPeriodo
		if (!datas) return null
		return {
			lojas: this.lojasSelecionadas && this.lojasSelecionadas.length ? this.lojasSelecionadas : undefined,
			dataInicial: datas.dataInicial,
			dataFinal: datas.dataFinal,
		}
	}

	@Watch('lojasSelecionadas')
	@Watch('periodoSelecionado')
	@Watch('datasPersonalizadas')
	aoMudarFiltro() { this.buscarDados() }

	async buscarDados() {
		const params = this.montarParams()
		if (!params) return
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = Axios.CancelToken.source()
			const cfg = { cancelToken: this.cancelToken.token }
			this.carregando = true
			const uc = this.findDadosDeVendasUseCase

			this.vendaPorLoja = await uc.findDadosDeVendasOrcamentoPorLoja(params, cfg)

			if (this.umaLoja) {
				this.vendedor = await uc.findDadosDeVendasPorVendedorOrcamento(params, cfg)
				this.marca = await uc.findDadosDeVendaPorMarca(params, cfg)
				this.externasInternas = this.calcularPerc(await uc.findDadosVendasOrcamentoExternasDemonstracao(params, cfg))
				this.demonstracao = await uc.findDadosDeDemonstracaoPorLoja(params, cfg)
			} else {
				this.vendedor = []; this.marca = []; this.externasInternas = []; this.demonstracao = []
			}

			if (this.temPermissao('Porcentagem Tipo de Cliente')) {
				const dashGeral = await this.findDashBoardUseCase.findDashGeral(params, cfg)
				this.percVendasComESemCliente = dashGeral.percVendasComClientes
			} else {
				this.percVendasComESemCliente = null
			}
		} catch (error) {
			if (!Axios.isCancel(error)) AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	calcularPerc(itens: any[]): any[] {
		const total = itens.reduce((s, i) => s + this.toNumber(i.faturamento), 0) || 1
		return itens.map(i => ({ ...i, perc: ((this.toNumber(i.faturamento) / total) * 100).toFixed(2) + '%' }))
	}
}
